import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { I18nModule, ConfigModule, CmsConfig } from '@spartacus/core';
import { ListNavigationModule } from '@spartacus/storefront';
import { HelpModule } from '../help/help.module';
import { FooterNavigationService } from './footer-navigation.service';
import { FooterNavigationComponent } from './footer-navigation/footer-navigation.component';

@NgModule({
  declarations: [FooterNavigationComponent],
  imports: [
    CommonModule,
    I18nModule,
    HelpModule,
    ListNavigationModule,
    ConfigModule.withConfig({
      cmsComponents: {
        FooterNavigationComponent: {
          component: FooterNavigationComponent,
        },
      },
    } as CmsConfig),
  ],
  exports: [],
  providers: [FooterNavigationService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FooterNavigationModule {}
